import React, { useState } from 'react';
import { Table, ConfigProvider, theme } from 'antd';
import { Settings, ChevronLeft, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../Layout';

// Dữ liệu danh sách báo cáo bám sát theo hình ảnh mẫu
const reportsData = [
    { id: 'bao-cao-don-xin-nghi', title: 'Báo cáo đơn xin nghỉ', subTitle: '', viewer: { type: 'avatar', val: 'NP' } },
    // { id: 'bao-cao-don-vang-mat', title: 'Báo cáo đơn vắng mặt', subTitle: '', viewer: { type: 'icon', val: 'orange' } },
    // { id: 'bao-cao-don-lam-them', title: 'Báo cáo đơn làm thêm', subTitle: '', viewer: { type: 'icon', val: 'orange' } },
    { id: 'bao-cao-di-muon', title: 'Báo cáo đi muộn', subTitle: '', viewer: { type: 'text', val: '—' } },
    // { id: 'bao-cao-ve-som', title: 'Báo cáo về sớm', subTitle: '', viewer: { type: 'text', val: '—' } },
    // { id: 'bao-cao-chi-tiet-thoi-gian-lam-viec', title: 'Báo cáo chi tiết thời gian làm việc theo tháng', subTitle: '', viewer: { type: 'text', val: '—' } },
    // { id: 'bao-cao-gio-lam-viec-theo-phong-ban', title: 'Báo cáo giờ làm việc theo phòng ban', subTitle: '', viewer: { type: 'icon', val: 'orange' } },
    { id: 'bao-cao-tong-hop', title: 'Báo cáo tổng hợp', subTitle: '', viewer: { type: 'text', val: '—' } },
    // { id: 'bao-cao-tong-so-gio-lam-them', title: 'Báo cáo tổng số giờ làm thêm', subTitle: 'Theo dõi tổng số giờ làm thêm', viewer: { type: 'text', val: '—' } }
];

export default function ReportManagement() {
    const navigate = useNavigate();

    // Cấu hình các cột cho bảng
    const columns = [
        {
            title: 'Tiêu đề',
            dataIndex: 'title',
            key: 'title',
            render: (text, record) => (
                <div className="flex flex-col cursor-pointer" onClick={() => navigate(`/timekeeping-report/${record.id}`)}>
                    <span className="font-medium">
                        {text}
                    </span>
                    {record.subTitle && (
                        <span className="text-xs text-slate-400 dark:text-slate-500 italic mt-0.5">
                            {record.subTitle}
                        </span>
                    )}
                </div>
            )
        },
        {
            title: 'Người xem',
            dataIndex: 'viewer',
            key: 'viewer',
            width: 150,
            render: (viewer) => {
                if (viewer.type === 'avatar') {
                    return (
                        <div className="">
                            <div className="w-7 h-7 rounded-full bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-300 flex items-center justify-center text-xs font-semibold">
                                {viewer.val}
                            </div>
                        </div>
                    );
                }
                if (viewer.type === 'icon') {
                    return (
                        <div className="">
                            <div className="w-6 h-6 rounded bg-orange-500 text-white flex items-center justify-center text-xs font-bold shadow-sm">
                                🗂️
                            </div>
                        </div>
                    );
                }
                return <div className="text-slate-400 font-mono">--</div>;
            }
        }
    ];

    return (
        <ConfigProvider theme={{ algorithm: theme.defaultAlgorithm }}>
            <div className="h-screen w-full flex overflow-hidden bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-slate-100 font-sans">
                <Layout>
                    <div className="flex flex-col flex-1">
                        
                        {/* Phần Thông tin phía trên bảng (Số lượng bản ghi & nút Cài đặt) */}
                        <div className="flex items-center justify-between mb-4 shrink-0 text-sm text-slate-600 dark:text-slate-400">
                            <div className="flex items-center gap-2">
                                <Settings size={16} className="text-slate-400" />
                                <span>Hiển thị 1 - {reportsData.length} / {reportsData.length} bản ghi</span>
                            </div>
                            <button 
                                onClick={() => navigate('/reports/settings')} 
                                className="flex items-center gap-1.5 hover:text-slate-900 dark:hover:text-white transition-colors"
                            >
                                <Settings size={15} />
                                <span>Cài đặt</span>
                            </button>
                        </div>

                        {/* Bảng dữ liệu Báo cáo */}
                        <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl shadow-sm flex flex-col flex-1 min-h-0 overflow-hidden">
                            <div className="flex-1 overflow-y-auto">
                                <Table
                                    columns={columns}
                                    dataSource={reportsData}
                                    rowKey="id"
                                    pagination={false}
                                    size="middle"
                                    rowSelection={{
                                        type: 'checkbox',
                                        columnWidth: 48,
                                    }}
                                    onRow={(record) => ({
                                        onClick: () => navigate(`/timekeeping-reports/${record.id}`),
                                        className: 'cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors'
                                    })}
                                    className="custom-table"
                                />
                            </div>

                            {/* Phân trang phía dưới */}
                            <div className="flex items-center justify-between px-6 py-3 border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shrink-0">
                                <span className="text-[13px] text-slate-500 dark:text-slate-400 font-medium">
                                    Hiển thị {reportsData.length} bản ghi
                                </span>
                                <div className="flex gap-2">
                                    <button className="w-8 h-8 rounded border border-slate-200 dark:border-slate-700 flex items-center justify-center text-slate-400 bg-white dark:bg-slate-800">
                                        <ChevronLeft size={14} />
                                    </button>
                                    <button className="w-8 h-8 rounded border border-blue-200 dark:border-blue-800 flex items-center justify-center text-blue-700 dark:text-blue-400 font-bold bg-blue-50 dark:bg-blue-900/30">
                                        1
                                    </button>
                                    <button className="w-8 h-8 rounded border border-slate-200 dark:border-slate-700 flex items-center justify-center text-slate-400 bg-white dark:bg-slate-800">
                                        <ChevronRight size={14} />
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </Layout>

                {/* CSS tùy chỉnh bảng giao diện tối giản giống ảnh */}
                <style dangerouslySetInnerHTML={{
                    __html: `
                    .custom-table .ant-table { background: transparent !important; color: inherit; font-size: 14px; }
                    .custom-table .ant-table-thead > tr > th { 
                        background: #f8fafc !important; 
                        border-bottom: 1px solid #e2e8f0; 
                        color: #64748b; font-weight: 600; font-size: 12px; text-transform: uppercase;
                        padding: 12px 16px;
                    }
                    .dark .custom-table .ant-table-thead > tr > th { 
                        background: #0f172a !important; border-bottom-color: #334155; color: #94a3b8; 
                    }
                    .custom-table .ant-table-tbody > tr > td { 
                        border-bottom: 1px solid #f1f5f9; padding: 12px 16px; transition: background 0.15s;
                    }
                    .dark .custom-table .ant-table-tbody > tr > td { border-bottom-color: #334155; }
                    .custom-table .ant-table-tbody > tr:hover > td { background-color: #f8fafc !important; }
                    .dark .custom-table .ant-table-tbody > tr:hover > td { background-color: rgba(30, 41, 59, 0.5) !important; }
                `}} />
            </div>
        </ConfigProvider>
    );
}